/**
 * Donate (single) journey steps
 */
import { Navigate, Outlet } from 'react-router-dom';

import { getCurrencySymbol } from '@/locale';
import JourneyContainer from '@/services/journeys/JourneyContainer';
import ProvidersLibsContainer from '@/services/providersLibs/ProvidersLibsContainer';

import PaymentSelect from '@/features/paymentSelect/PaymentSelect';
import UserDetails from '@/features/userDetails/UserDetails';
import PaymentForm from '@/features/paymentProcess/PaymentForm';
import PaymentSuccess from '@/features/paymentProcess/PaymentSuccess';
import PaymentSubmitted from '@/features/paymentProcess/PaymentSubmitted';
import PaymentFailure from '@/features/paymentProcess/PaymentFailure';
import PaymentError from '@/features/paymentProcess/PaymentError';

const currencySymbol = getCurrencySymbol();
const singleRouteSteps = 6;

const donateSingleRoutes = {
  path: '/donate',
  element: (
    <ProvidersLibsContainer>
      <JourneyContainer journey="single">
        <Outlet />
      </JourneyContainer>
    </ProvidersLibsContainer>
  ),
  children: [
    // Redirect from "/donate" index to "./payment-select"
    {
      path: '',
      element: <Navigate to="./payment-select" replace />,
    },
    {
      path: 'payment-select',
      element: <PaymentSelect
        providerGroup="single"
        totalSteps={singleRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'user-details',
      element: <UserDetails
        providerGroup="single"
        totalSteps={singleRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'card-payment',
      element: <PaymentForm
        totalSteps={singleRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'success',
      element: <PaymentSuccess
        totalSteps={singleRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'submitted',
      element: <PaymentSubmitted
        currencySymbol={currencySymbol}
        totalSteps={singleRouteSteps}
      />,
    },
    {
      path: 'failure',
      element: <PaymentFailure />,
    },
    {
      path: 'error',
      element: <PaymentError />,
    },
  ],
};

export default donateSingleRoutes;
